import { IBlock, UslugaFindByUrlResponse } from "@project/shared-types";
import { useMemo } from "react";
import { BLOCKS } from "./BLOCKS";

export const BlocksBuilder = ({
  data
}: {
  data: UslugaFindByUrlResponse
}) => {

  const get_component = (block: IBlock) => {
    const Component = BLOCKS[block.type];
    console.log(`data.preview_id ${data.usluga?.product_id}`);
    if (Component) {
      const SETTINGS: Partial<Record<string, Record<string, any>>> = {
        main_usluga: {
          key: block.id,
          block: block,
          preview_id: data.usluga?.product_id,
          data: data,
        },
        fast_payment: {
          key: block.id,
          block: block,
          defaultServiceId: data.usluga?.product_id,
          data: data,
        },
        how: { key: block.id, block: block },
      };
      const Setting = SETTINGS[block.type];
      if (Setting) {
        const { key, ...rest } = Setting;
        return <Component key={key}  {...rest} />;
      } else {
        return <Component key={block.id} block={block} />;
      }
    } else {
      console.warn(`Не найден компонент для блока ${block.type}`);
      return null;
    }
  };
  const blocks = useMemo(() => {
    return data.blocksGroup?.blocks || [];
  }, [data.blocksGroup]);
  return (
    <>
      {data && data.usluga && (
        <>{blocks.map((block) => get_component(block))}</>
      )}
    </>
  );
};
